module.exports = __webpack_public_path__ + "img/circular_layout.e3f3abed.png";